import en from './en';
import es from './es';
import pt from './pt';

export type Dictionaries = Record<string, string>;

const dictionaries: Record<string, Dictionaries> = {
  en,
  es,
  pt,
};

export default dictionaries;
